"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("./client");
const logger_1 = require("./logger");
const DEFAULT_STAGE = 'staging';
const DEFAULT_REGION = 'us-west-2';
const DEFAULT_HOST = 'api.snap.menu';
const DEFAULT_BILLING_STREAM = 'dts-billing';
class ApiError extends Error {
    constructor(obj) {
        super(typeof obj === 'string' ? obj : obj.message || 'API error.');
        Object.keys(obj).forEach(x => this[x] = obj[x]);
        this.name = 'ApiError';
    }
}
exports.ApiError = ApiError;
class DtsApi {
    get client() {
        return this.api;
    }
    constructor(cfg = {}) {
        const config = Object.assign({}, cfg);
        if (!config.env) {
            config.env = process.env.NODE_ENV || DEFAULT_STAGE;
        }
        if (!config.region) {
            config.region = DEFAULT_REGION;
        }
        if (config.logger) {
            this.logger = config.logger;
        }
        else {
            this.logger = new logger_1.ConsoleLogger();
        }
        if (!config.api) {
            if (config.env === 'production') {
                config.api = { host: DEFAULT_HOST, path: '/server-v3' };
            }
            else {
                config.api = { host: DEFAULT_HOST, path: `/server-v4` };
            }
        }
        else {
            if (!config.api.spec) {
                if (!config.api.host) {
                    config.api.host = DEFAULT_HOST;
                }
                if (!config.api.path) {
                    config.api.path = `/server-v4`;
                }
            }
        }
        if (!config.billing) {
            config.billing = {
                stream: DEFAULT_BILLING_STREAM,
            };
        }
        this.logger.debug({ region: config.region, env: config.env }, 'API client started.');
        const options = {
            logger: this.logger
        };
        this.api = new client_1.DtsApiClient(config, options);
    }
}
exports.DtsApi = DtsApi;
exports.default = DtsApi;
